module.exports = __webpack_public_path__ + "b8b68d56213c483b0ae9545eef5e68d3.pdf";